import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import flatten from 'lodash.flatten';
import { groupNodeEntities } from './helpers';
import injectBanner from '../../inject-banner';
export default function getBannersForNodes(entitiesSet, banner) {
  const groups = groupNodeEntities(entitiesSet, banner);
  const nodesWithBanner = groups.map((chunk, index) => {
    const key = `${banner.adunit}-${index}`;
    const interval = chunk.length + 1;
    return injectBanner(chunk, _objectSpread(_objectSpread({}, banner), {}, {
      key,
      interval
    }));
  }).map(flatten);
  return nodesWithBanner;
}
//# sourceMappingURL=get-banners-for-nodes.js.map